import React from 'react';
import { AbstractButton, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import useAIPanelV3 from 'Hooks/useAIPanelV3';

/**
 * Vertical "Panther AI" toggle tab. Absolutely positioned to the left of
 * the AI panel so it never affects layout flow. Returns null when no
 * content is portaled (non-AI pages or inactive tabs).
 */
const AIPanelToggleTabV3: React.FC = () => {
  const { hasContent, toggle, title, isOpen } = useAIPanelV3();
  const {
    palette: { tokens },
  } = useTheme();

  const handleClick = React.useCallback(() => {
    toggle({ title: title || 'AI Assistant' });
  }, [toggle, title]);

  if (!hasContent) {
    return null;
  }

  return (
    <AbstractButton
      onClick={handleClick}
      aria-label={isOpen ? 'Close AI panel' : 'Open AI panel'}
      data-testid="ai-panel-toggle-tab"
      backgroundColor={tokens.content.assets.semantic.info['2']}
      color={tokens.content.text.basic.white}
      py={3}
      px={1.5}
      borderRadius="0 12px 12px 0"
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      _hover={{ backgroundColor: tokens.content.assets.semantic.info['4'] }}
      transform="rotate(180deg)"
      position="absolute"
      right="100%"
      top="50%"
      zIndex={1}
      sx={{
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
        translateY: '-50%',
      }}
    >
      <Text fontSize="small" fontWeight="bold" letterSpacing="0.05em" whiteSpace="nowrap">
        Panther AI
      </Text>
    </AbstractButton>
  );
};

export default AIPanelToggleTabV3;
